import { registerPlugin } from '@capacitor/core';
const NowPlaying = registerPlugin('NowPlaying', {
    web: () => import('./web').then((m) => new m.NowPlayingWeb()),
});
export { NowPlaying };
